export default function initLoadMoreCategories() {
    const button = document.querySelector('#js-load-more-categories');
    const grid = document.querySelector('#js-category-grid');

    if (!button || !grid) return;

    const label = button.querySelector('.c-compound-btn__label');
    const originalText = label.textContent;

    button.addEventListener('click', async () => {
        const currentPage = parseInt(button.dataset.page);

        const ajaxUrl = window.pdrData ? pdrData.ajax_url : '/wp-admin/admin-ajax.php';
        const ppp = window.pdrData ? pdrData.ppp : 9;
        const parentId = button.dataset.parentId || 0;

        button.disabled = true;
        label.textContent = 'Carregando...';

        const params = new URLSearchParams();
        params.append('action', 'load_more_categories');
        params.append('page', currentPage);
        params.append('ppp', ppp);
        params.append('parent_id', parentId);

        try {
            const response = await fetch(ajaxUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: params
            });

            const isLastPage = response.headers.get('X-Last-Page');
            const html = await response.text();

            if (html.trim().length > 10) {
                grid.insertAdjacentHTML('beforeend', html);
                button.dataset.page = currentPage + 1;
                button.disabled = false;
                label.textContent = originalText;
            }

            if (isLastPage === 'true' || html.trim().length < 10) {
                button.parentElement.remove();
            }
        } catch (error) {
            console.error('Erro no AJAX:', error);
            label.textContent = 'Tentar novamente';
            button.disabled = false;
        }
    });
}